'use client';

import { use } from 'react';

//* HOC's
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

//* Helpers
import breakString from '@helpers/breakString';

//* Lib
import { fetchSectionData } from '@/lib/get-data';

//* Components
import LazySection from '../LazySection';
import Button from '@components/global/Button';
import MinTitle from '@components/global/MinTitle';
import PortfolioList from '@components/cfModules/PortfolioList';
import PortfolioListSkeleton from '@/components/skeleton/PortfolioListSkeleton';

const PortfolioShortListContent = ({ active, title, serviceType, portfolioFull, translate, selectedLang }) => {
	const data = use(fetchSectionData({ name: 'getPortfolioShortList', lang: selectedLang, params: { serviceType } }));
	const itemCount = data?.items ? Object.keys(data.items).length : 0;
	if (!itemCount) return null;

	return (
		<>
			<MinTitle
				active={active}
				title={breakString(title)}
			/>

			<PortfolioList
				data={data}
				serviceType={serviceType}
				portfolioFull={portfolioFull}
			/>

			<Button
				type={1}
				link={'/portfolio/'}
				customClass='load-more'
				text={translate('allWorksHere')}
				ariaLabel={translate('allWorksHere')}
			/>
		</>
	);
};

const PortfolioShortList = ({ active, title, serviceType, portfolioFull, translate, selectedLang }) => {
	return (
		<LazySection
			delay={500}
			fallback={<PortfolioListSkeleton />}>
			<PortfolioShortListContent
				active={active}
				title={title}
				serviceType={serviceType}
				portfolioFull={portfolioFull}
				translate={translate}
				selectedLang={selectedLang}
			/>
		</LazySection>
	);
};

export default withLanguageContext(PortfolioShortList, ['translate', 'selectedLang']);
